var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { BaseComponent } from '../base.component';
import { MatDialogRef } from '@angular/material';
import { SuccessWrapComponent } from '../success.wrap/success.wrap.component';
import { CreateTripModalActions } from './create.trip.modal.provider';
var CreateTripModalComponent = /** @class */ (function (_super) {
    __extends(CreateTripModalComponent, _super);
    function CreateTripModalComponent(dialogRef, activatedRoute, actions, formBuilder, visitorApiService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.dialogRef = dialogRef;
        _this.activatedRoute = activatedRoute;
        _this.actions = actions;
        _this.formBuilder = formBuilder;
        _this.visitorApiService = visitorApiService;
        _this.newTripLabel = 'Type here such as "Day 1 - Family Vacation"';
        _this.tripFormGroup = _this.formBuilder.group({
            'tripTitle': [null, [Validators.required]],
        });
        if (_this.isMobile) {
            _this.newTripLabel = 'Type here such as "Day 1"';
        }
        return _this;
    }
    CreateTripModalComponent.prototype.createTrip = function ($event) {
        if (!this.newTripTitle) {
            return;
        }
        this.actions.confirm(this.newTripTitle, $event);
        this.dialogRef.close();
    };
    CreateTripModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return CreateTripModalComponent;
}(BaseComponent));
export { CreateTripModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/create.trip.modal/create.trip.modal.component.ts.pre-build-optimizer.js